import type { JSX } from 'react';

import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

export const GearIcon = (props: SVGProps): JSX.Element => {
  return <SpriteIcon spriteId="settings" {...props} />;
};
